import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { SiteEmployeeType } from '../../Types/HeyTraderTypes/Attendances/SiteEmployeeType';
import { getAttendanceEmployeeListNew } from '../../Thunks/NewAttendanceThunks';

interface NewAttendanceEmployeeSliceState {
  loader: boolean; // for refres pages and inital loadings
  attendanceEmployeeList: SiteEmployeeType[];
  errorDisplay: string | null;
}

// set inital valus
const initialState: NewAttendanceEmployeeSliceState = {
  loader: false,
  attendanceEmployeeList: [],
  errorDisplay: '',
}

// set state valu for api response
const newAttendanceEmployeeSlice = createSlice({
  name: 'newAttendanceEmployeeSlice',
  initialState,
  reducers: {
  },
  extraReducers(builder) {
    builder
      .addCase(getAttendanceEmployeeListNew.rejected, (state, action) => {
        state.loader = false;
        state.errorDisplay = action.error.message!;
      })

      .addCase(getAttendanceEmployeeListNew.pending, state => {
        state.loader = true;
        state.errorDisplay = null;
      })
      
      .addCase(getAttendanceEmployeeListNew.fulfilled, (state, action: PayloadAction<SiteEmployeeType[]>) => {
        state.loader = false;
        state.attendanceEmployeeList = action.payload;
      })
  }
})

export const { } = newAttendanceEmployeeSlice.actions
export default newAttendanceEmployeeSlice.reducer
